import { useState } from "react";

import { config as springConfig, useTransition } from "@react-spring/web";

const useSlides = ({ slides }: { slides: any[] }) => {
  const [activeSlideIndex, setActiveSlide] = useState(0);

  const jumpToSlide = (i: number) => {
    setActiveSlide(i);
  };

  const nextSlide = () => {
    setActiveSlide((activeSlideIndex + 1) % slides.length);
  };

  const showNext = activeSlideIndex < slides.length - 1;

  const transition = useTransition(activeSlideIndex, {
    initial: { opacity: 0, transform: "translate3d(0%,0,0)" },
    from: { opacity: 0, transform: "translate3d(100%,0,0)" },
    enter: { opacity: 1, transform: "translate3d(0%,0,0)" },
    leave: { opacity: 0, transform: "translate3d(-100%,0,0)" },
    config: { ...springConfig.slow, mass: 3 },
  });

  return { activeSlideIndex, jumpToSlide, nextSlide, showNext, transition };
};

export default useSlides;
